export default __webpack_public_path__ + "d0a2b46b68dcd2865e8f3b0568fc6cd6.pdf";